import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function Share({
  color = 'icon.arrowBlue',
  strokeWidth = '1.5',
  fill = 'transparent',
  ...props
}) {
  return (
    <IconBase viewBox='0 0 16 16' {...props}>
      <Path
        d='M4.98377 6.35538C5.89512 7.26673 5.89512 8.7443 4.98377 9.65565C4.07243 10.567
        2.59485 10.567 1.68351 9.65565C0.772164 8.7443 0.772164 7.26673 1.68351 6.35538C2.59485
        5.44404 4.07243 5.44404 4.98377 6.35538'
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
      <Path
        d='M14.3119 1.68351C15.2232 2.59485 15.2232 4.07243 14.3119 4.98377C13.4006 5.89512
        11.923 5.89512 11.0116 4.98377C10.1003 4.07243 10.1003 2.59485 11.0116 1.68351C11.923
        0.772164 13.4006 0.772164 14.3119 1.68351'
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
      <Path
        d='M14.3119 11.0116C15.2232 11.923 15.2232 13.4006 14.3119 14.3119C13.4006 15.2232
        11.923 15.2232 11.0116 14.3119C10.1003 13.4006 10.1003 11.923 11.0116 11.0116C11.923
        10.1003 13.4006 10.1003 14.3119 11.0116'
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
      <Path
        d='M5.40625 6.9572L10.5863 4.36719'
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
      <Path
        d='M5.40625 9.03906L10.5863 11.6291'
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
    </IconBase>
  )
}

Share.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
  strokeWidth: PropTypes.string,
}

export default Share
